// import moment from 'moment';
import styled from 'styled-components';
import { useNavigate, Link } from 'react-router-dom';
// import { defaultImage } from '../../methods/utils/general-utils';

interface IBook {
	item: any;
}

const Style = styled.div`
	padding: 20px;
	background-color: #f8f8f8;
	margin-bottom: 10px;
	display: grid;
	justify-content: space-between;
	grid-template-columns: 1fr 1fr 1fr;
	cursor: pointer;

	& .label {
		font-size: 13px;
		color: #808080;
		font-style: italic;
	}

	& .green {
		font-size: 13px;
		color: green;
		font-style: italic;
		padding-left: 5px;
		text-transform: capitalize;
	}

	& .red {
		font-size: 13px;
		color: red;
		font-style: italic;
		padding-left: 5px;
		text-transform: capitalize;
	}

	& .balance {
		display: flex;

		& img {
			width: 24px;
			height: 24px;
			border-radius: 50%;
			margin-right: 10px;
		}
	}
`;

const Book = ({ item }: IBook) => {
	const navigate = useNavigate();
	const handleClick = (id: string) => {
		navigate(`./${id}`);
	};

	return (
		<Link
			to={`./${item?._id}`}
			style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
		>
			<Style onClick={() => handleClick(item?._id)}>
				<div>{item?.title}</div>

				<div>
					<div className="balance">
						<p>
							<strong>{item?.funder?.email}</strong>
						</p>
					</div>
				</div>
				<div>
					<p className={item?.status === 'active' ? 'green' : 'red'}>
						{item?.status}
					</p>
				</div>
			</Style>
		</Link>
	);
};

export default Book;
